import { schema } from 'normalizr';
import productSchema from './productSchema';

const packageItemSchema = new schema.Entity('packageItems', {
  package: productSchema,
  product: productSchema,
});

export default packageItemSchema;
